import {buildDescriptorControl} from "../descriptorcontrols/ControlResolver";

export default (props) => buildDescriptorControl("DateField", "calendar", props);



// WEBPACK FOOTER //
// ./app/lib/common/controls/Date.js